export const SHOW_CREATE_PROJECT = 'SHOW_CREATE_PROJECT';
export const HIDE_CREATE_PROJECT = 'HIDE_CREATE_PROJECT';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SET_VIEW = 'SET_VIEW';
export const SHOW_UPDATE_PROJ = 'SHOW_UPDATE_PROJ';
export const HIDE_UPDATE_PROJ = 'HIDE_UPDATE_PROJ';
export const SHOW_COPY_PROJECT = 'SHOW_COPY_PROJECT';
export const HIDE_COPY_PROJECT = 'HIDE_COPY_PROJECT';
export const SHOW_DEL_PROJECT = 'SHOW_DEL_PROJECT';
export const HIDE_DEL_PROJECT = 'HIDE_DEL_PROJECT';
export const SHOW_TAGS = 'SHOW_TAGS';
export const HIDE_TAGS = 'HIDE_TAGS';
export const ASSIGN_TAGS = 'ASSIGN_TAGS';
export const RESET_UPDTAG = 'RESET_UPDTAG';
export const SHOW_PKGS = 'SHOW_PKGS';
export const HIDE_PKGS = 'HIDE_PKGS';
export const CREATE_PKG = 'CREATE_PKG';
export const UPDATE_PKG = 'UPDATE_PKG';
export const HIDE_PKG = 'HIDE_PKG';
export const REFRESH_APP = 'REFRESH_APP';
export const DESTROYED_GRID = 'DESTROYED_GRID';
export const CHANGE_WS_TAB = 'CHANGE_WS_TAB';

export const FETCH_LOOKUP_START = 'FETCH_LOOKUP_START';
export const FETCH_LOOKUP_SUCCESS = 'FETCH_LOOKUP_SUCCESS';
export const FETCH_LOOKUP_FAILURE = 'FETCH_LOOKUP_FAILURE';

export const CONF_ROUTING_CHECK_START = 'CONF_ROUTING_CHECK_START';
export const CONF_ROUTING_CHECK_SUCCESS = 'CONF_ROUTING_CHECK_SUCCESS';
export const CONF_ROUTING_CHECK_FAILURE = 'CONF_ROUTING_CHECK_FAILURE';

export const GET_CONF_SESSIONID_START = 'GET_CONF_SESSIONID_START';
export const GET_CONF_SESSIONID_SUCCESS = 'GET_CONF_SESSIONID_SUCCESS';
export const GET_CONF_SESSIONID_FAILURE = 'GET_CONF_SESSIONID_FAILURE';

export const CONFIT_CREATE_QUOTE_START = 'CONFIT_CREATE_QUOTE_START';
export const CONFIT_CREATE_QUOTE_SUCCESS = 'CONFIT_CREATE_QUOTE_SUCCESS';
export const CONFIT_CREATE_QUOTE_FAILURE = 'CONFIT_CREATE_QUOTE_FAILURE';

export const CONFIT_UPDATE_QUOTE_START = 'CONFIT_UPDATE_QUOTE_START';
export const CONFIT_UPDATE_QUOTE_SUCCESS = 'CONFIT_UPDATE_QUOTE_SUCCESS';
export const CONFIT_UPDATE_QUOTE_FAILURE = 'CONFIT_UPDATE_QUOTE_FAILURE';

export const SET_CONF_INIT = 'SET_CONF_INIT';
